import { Globe, Moon, Sun } from 'lucide-react';
import { LOCALES, useT } from '../i18n';
import { Dropdown, IconButton } from '../ui';
import { useThemeStore } from '../app/theme';

/** Langue + thème, disponibles avant la connexion. */
export function LoginControls() {
  const { t, locale, setLocale } = useT();
  const theme = useThemeStore((x) => x.theme);
  const toggle = useThemeStore((x) => x.toggle);
  return (
    <>
      <Dropdown
        items={LOCALES.map((l) => ({ id: l.code, label: `${l.code === locale ? '✓ ' : ''}${l.label}`, onSelect: () => setLocale(l.code) }))}
        trigger={(props) => <IconButton label={t('shell.language')} icon={<Globe size={20} />} {...props} />}
      />
      <IconButton
        label={theme === 'dark' ? t('shell.themeLight') : t('shell.themeDark')}
        icon={theme === 'dark' ? <Sun size={20} /> : <Moon size={20} />}
        onClick={toggle}
      />
    </>
  );
}
